<div>
    <div aria-labelledby="profile-tab" class="tab-pane fade" id="profile" role="tabpanel">

        <div class="container-fluid">
            <div class="content-block">
                <div class="error-list" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li :key="x" v-for="(error,x) in ui.error.error_message">
                            <div :key="i" v-for="(err,i) in error">
                                <p> {{err}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="form-modified">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Select social media
                        </label>
                        <div class="col-lg-3">
                            <div class="multiselect-input" v-if="item.socialMediaIconList">
                                <multiselect :class="{ 'error-input' : ui.error.errors['social_media'] }" :custom-label="customLabel" :option-height="40" :options='item.socialMediaIconList'
                                             :show-labels="false" :track-by="'name'" label="name"
                                             placeholder="Choose icon" v-model="item.socialMediaData.social_media">
                                    <template slot="singleLabel" slot-scope="props"><img :src="props.option.icon_path"
                                                                                         alt="No Man’s Sky" class="option__image"><span
                                            class="option__desc"><span
                                            class="option__title">{{ props.option.name }}</span></span></template>
                                    <template slot="option" slot-scope="props"><img :src="props.option.icon_path"
                                                                                    alt="No Man’s Sky" class="option__image">
                                        <div class="option__desc"><span class="option__title">{{ props.option.name }}</span>
                                        </div>
                                    </template>
                                </multiselect>
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'social_media'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>
                        </div>

                        <div class="col-lg-5">
                            <div class="form-group">
                                <input :class="{ 'error-input' : ui.error.errors['link'] }" class="form-control" placeholder="Enter link" type="text"
                                       v-model="item.socialMediaData.link">
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'link'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <button :disabled="ui.status.postLoading.saveSocialMedia" @click.prevent="saveSocialAccount" class="btn default-btn"
                                    type="button">
                                Save
                                <spinner
                                        :loading="ui.status.postLoading.saveSocialMedia"
                                        v-if="ui.status.postLoading.saveSocialMedia"
                                ></spinner>
                            </button>
                        </div>
                    </div>
                    <hr>
                    <div class="empty-data">
                        <p v-if="!item.socialMediaList">No Social Media List</p>
                    </div>
                    <div :key="index" class="form-group row"
                         v-for="(social, index) in item.socialMediaList" v-if="item.socialMediaList">
                        <div class="col-lg-8 offset-lg-2">
                            <div class="includes-list-item">

                                <div class="includes-list hoverable-list readonly" v-if="!social.IsActive">
                                    <span class="social-float-icons">
                                        <img :src="social.social_media.icon_path" v-if="social.social_media">
                                         <i class="fab fa-facebook-f" v-else></i>
                                    </span>
                                    {{social.link}}
                                </div>

                                <div class="includes-list editable" v-else>
                                    <div class="form-group">
                                        <label for=""></label>
                                        <div class="multiselect-input" v-if="item.socialMediaIconList">
                                            <multiselect :class="{ 'error-input' : ui.error.errors['edit_social_media'] }" :custom-label="customLabel" :option-height="40" :options='item.socialMediaIconList'
                                                         :show-labels="false" :track-by="'name'" label="name"
                                                         placeholder="Choose icon" v-model="item.editsocialMediaData.social_media">
                                                <template slot="singleLabel" slot-scope="props"><img :src="props.option.icon_path"
                                                                                                     alt="No Man’s Sky" class="option__image"><span
                                                        class="option__desc"><span
                                                        class="option__title">{{ props.option.name }}</span></span></template>
                                                <template slot="option" slot-scope="props"><img :src="props.option.icon_path"
                                                                                                alt="No Man’s Sky" class="option__image">
                                                    <div class="option__desc"><span
                                                            class="option__title">{{ props.option.name }}</span></div>
                                                </template>
                                            </multiselect>
                                            <validation-error
                                                    :errors="ui.error.errors"
                                                    :field="'edit_social_media'"
                                                    :isError="ui.error.has_error"
                                                    v-if="ui.error.has_error"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <input :class="{ 'error-input' : ui.error.errors['edit_link'] }" class="form-control" placeholder="Enter link" type="text"
                                               v-model="item.editsocialMediaData.link">
                                        <validation-error
                                                :errors="ui.error.errors"
                                                :field="'edit_link'"
                                                :isError="ui.error.has_error"
                                                v-if="ui.error.has_error"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="includes-action">
                                <button @click.prevent="onEditSocialAccountClick(social, index)" class="btn blue" type="button"
                                        v-if="!ui.status.canEdit"><i
                                        class="fas fa-pen"></i></button>
                                <button @click.prevent="saveEditedSocialAccount()" class="btn green" type="button"
                                        v-if="social.IsActive"><i class="fas fa-save"></i></button>
                                <button @click.prevent="onCancelSocialAccountClick(social, index)" class="btn red" type="button"
                                        v-if="social.IsActive"><i
                                        class="fas fa-times"></i></button>
                                <button @click.prevent="onDeleteSocialAccountClick(index,social)" class="btn red"
                                        type="button"
                                        v-if="!social.IsActive"><i
                                        class="fas fa-minus"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-wrap">
        <div
                aria-labelledby="exampleModalLabel"
                class="modal fade show"
                id="deleteSocialAccount"
                role="dialog"
                tabindex="-1"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete Social Account</h5>
                        <button
                                aria-label="Close"
                                class="close"
                                data-dismiss="modal"
                                type="button"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="error-list" v-if="ui.error.modal.delete">
                        <ul class="error-msg">
                            <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                    <div class="modal-body">
                        <p>
                            Are you sure you want to delete this ?
                        </p>
                    </div>

                    <div class="modal-footer">
                        <button
                                @click.prevent="deleteSocialAccount()"
                                class="btn default-btn"
                                type="button"
                        >
                            Ok
                            <spinner :loading="ui.status.postLoading.deleteSocialMedia" v-if="ui.status.postLoading.deleteSocialMedia"></spinner>
                        </button>
                        <button
                                :disabled="ui.status.postLoading.deleteSocialMedia"
                                @click.prevent="hideDeleteModal"
                                aria-label="Close"
                                class="btn default-btn cancel" type="button"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
